// **** colaboradores ****
// **** autor: Walcledson de Paula ****
// **** 11-08-24 | 16h23 ****
// **** atualizado: 27/8/24 10h46 ****
// **** atualizado: 10/9/24 21h23 **** // acrescentado token jwt
// **** atualizado: 14/10/24 12h19 **** // acrescentado fone, dt cadastro, 
//                  (botões: novo colaborador e editar - foram substituídos o CardColaborador 
//                  por novas páginas individuais) // eliminado o Dock 
//                  id_usuario agora é extraído via p_getUserData (a outra forma foi eliminada)



import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { decrypt } from "../../../../../Services/cryptoUtils.js";
import Swal from "sweetalert2";
import { Oval } from 'react-loader-spinner';
import Icon from '@mdi/react'; // icone do material design icones pra padronizar o home do mobile/desktop (delphi) no web 2/7/24w
import { mdiPlusCircle , mdiAccountEdit, mdiAccountWrench, mdiInvoiceTextClockOutline } from '@mdi/js'; // novo // alterar
import apiaxios from "../../../../../Services/apiaxios.js";
import handleApiError from "../../../../../Services/apiErrorHandler.js";
import { AutoLogout } from "../../../../../Services/autologout.js";
import Menu from '../../../Components/Menu/p_menu.jsx';
import Footer from "../../../../AgendexCliente/components/Footer/footer.jsx";

import './p_colaboradores.css';
import { p_getUserData } from "../../../../../Services/p_userutils.js";

function Colaboradores() {
    // verifica se os tokens estão presentes e não inválidos
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    const tokenlg = localStorage.getItem("tokenlg");

    // verifica se os tokens estão presentes e não inválidos
    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            console.error('token adulterado');
            AutoLogout();
        }
    }, [tokenASW, tokenlg]);

    const initialUserData = p_getUserData();
    const [userId, setUserId] = useState(initialUserData.userId); // Usar setIdUsuario para atualizar o id_usuario
    const [validado, setValidado] = useState(initialUserData.validado); // CPF/CNPJ validado =1 (se ainda não foi validado = 0)
    const [bloqueio, setBloqueio] = useState(initialUserData.bloqueio); // se contrato vencido ou não (0= não vencido / 1=vencido)

    const [loading, setLoading] = useState(false);
    const [colaboradores, setColaboradores] = useState([]);
    // const [selectedColaborador, setSelectedColaborador] = useState(null);
    const [nenhumColaboradorEncontrado, setNenhumColaboradorEncontrado] = useState(false);
    const navigate = useNavigate();
    const [alterouSalvouColaborador, setAlterouSalvouColaborador] = useState(false);
    const alteradoSalvoColaborador = () => setAlterouSalvouColaborador(true);
    
    useEffect(() => {
        try {
            const encryptedUser = localStorage.getItem('tokenapw');
            if (encryptedUser) {
                const decryptedUser = decrypt(encryptedUser);
                if (decryptedUser && decryptedUser.id_usuario) {
                    setUserId(decryptedUser.id_usuario);
                } else {
                    throw new Error('Token inválido');
                }
            } else {
                throw new Error('Token não encontrado');
            }
        } catch (error) {
            console.error('Erro ao descriptografar ou validar token:', error);
            AutoLogout();
        }
    }, []);

    useEffect(() => {
        // console.log('validado dentro de detalhe empresa: ', validado);
        // console.log('bloquio dentro de detalhe empresa: ', bloqueio);
        // if (validado === 0 || validado === undefined || validado === null) {
        if (validado !== 1) {
            Swal.fire('Erro', 'Cadastro em validação... favor aguardar e tentar novamente mais tarde!', 'error');
            navigate('/app/prestador/home');
        } else if (bloqueio !== 0) {
            Swal.fire('Contrato Vencido', 'Cadastro bloqueado. Escolha um de nossos planos para continuar usando o AgendeX', 'error');
            navigate('/app/prestador/home');
        }
    }, [validado, bloqueio, navigate]); // acrescetando 12/9/24w "navigate" pois estava gerando o hint/warning: "Line 147:8:   React Hook useEffect has a missing dependency: 'navigate'. Either include it or remove the dependency array"

    useEffect(() => {
        const loadColaboradores = async () => {
            if (userId) {
                try {
                    const empresaColaboradores = await fetchColaboradores(userId);
                    setColaboradores(empresaColaboradores);
                } catch (error) {
                    console.error('Erro ao buscar colaboradores:', error);
                }
            }
        };
        loadColaboradores();
    }, [userId, alterouSalvouColaborador]);

    const fetchColaboradores = async (id_empresa) => {
        try {
            setLoading(true);
            // const colaboradoresResponse = await apiaxios.get(`/empresa/colaboradorWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`); // acrescentamos o token jwt na requisição 10/9/24w
            const colaboradoresResponse = await apiaxios.get(`/colaborador/listarWeb?id_empresa=${id_empresa}&id_usuario=${id_empresa}&token=${tokenASW}`); // acrescentamos o token jwt na requisição 10/9/24w
            setLoading(false);
            if (colaboradoresResponse.status === 200 && colaboradoresResponse.data.length > 0) {
                // Mapear o array de colaboradores e converter as imagens
                // console.log('colaboradoresResponse : ', colaboradoresResponse);
                const colaboradores = colaboradoresResponse.data.map(colaborador => {
                    return {
                        ...colaborador,
                        COL_FOTO: colaborador.COL_FOTO ? `data:image/jpeg;base64,${colaborador.COL_FOTO}` : null,
                        COL_FOTOMINI: colaborador.COL_FOTOMINI ? `data:image/jpeg;base64,${colaborador.COL_FOTOMINI}` : null,
                    };
                });
                return colaboradores;
            } else {
                Swal.fire('Nenhum colaborador cadastrado. Cadastre seu primeiro colaborador/funcionário no botão (+) acima');
                return [];
            }
        } catch (error) {
            handleApiError(error);
            return [];
        } finally {
            setLoading(false);
        }
    };

    const handleAlterar = (colaborador) => {
        navigate(`/app/prestador/empresa/colaboradores/${colaborador.COL_ID}`, {state: { colaborador }});
    };

    const handleHorarios = () => {
        navigate('/app/prestador/empresa/colaboradores/horarios');
    };

    const handleServicos = () => {
        navigate('/app/prestador/empresa/colaboradores/servicos');
    };

    const handleAdicionar = () => {
        navigate('/app/prestador/empresa/colaboradores/novo');
    };

    const handleDesativar = (id_colaborador) => {
        // alert('Função desativar colaborador temporariamente');
        Swal.fire('Atenção', 'Função indisponível nesta versão. Estamos trabalhando para melhorar o Agendex a cada dia. #All-in-one. #TudoNumSóLugar', 'info');
    };

    const handleExcluir = (id_colaborador) => {
        Swal.fire({
            title: 'Confirmação',
            text: 'Confirma a exclusão do Colaborador id #' + id_colaborador + ' ?' ,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetchExcluircolaborador(id_colaborador);
            }
        })
    };

    const fetchExcluircolaborador = async (id_colaborador) => {
        setLoading(true);
            try {
                const response = await apiaxios.delete('empresa/colaboradorCrudWeb', {
                    params: { id_empresa: userId,
                        id_colaborador,
                        id_usuario: userId,
                        token: tokenASW
                    }
                });
                if (response.status === 200) {
                    const data = response.data;
                    if (data.retorno === 'OK') {
                        Swal.fire('Informação', 'Colaborador excluído com sucesso!', 'success');
                        fetchColaboradores(userId);
                    } else {
                        Swal.fire('Erro', data.retorno, 'error');
                    }
                } else { if (response.status !== 200) {
                    const data = response.data;
                    Swal.fire('Erro', data.retorno, 'error');
                    } else {
                        Swal.fire('Erro', 'Falha ao excluir o Colaborador. Tente novamente mais tarde.', 'error');
                    }
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                setLoading(false);
            }
    };  



    return <>
        <div className="p_colaboradores">
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                        <Menu page="colaboradores"/>
                    </div>
                    <div className="col py-2 me-3">
                        <div className="container-fluid">
                            <h1 className="text-center">Colaboradores / Funcionários</h1>
                            <hr />
                            <div className="text-right">
                                <button type='button' className="btn btn-info m-2" onClick={() => handleHorarios()}>
                                    <Icon path={mdiInvoiceTextClockOutline } size={1} className="me-2"/>Horários
                                </button>
                                <button className="btn btn-info m-2" onClick={() => handleServicos()}>
                                    <Icon path={mdiAccountWrench } size={1} className="me-2"/>Serviços
                                </button>
                                <button className="btn btn-primary m-2" onClick={() => handleAdicionar()}>
                                    <Icon path={mdiPlusCircle} size={1} className="me-2"/>Novo Colaborador
                                </button>
                            </div>
                            <div className={`row ${loading ? 'd-none' : ''}`}></div>
                            {loading && (
                                <div className="loading-spinner-container">
                                    <Oval color="#00BFFF" height={80} width={80} />
                                </div>
                            )}
                            {nenhumColaboradorEncontrado ? (
                                <div className="alert alert-danger mt-2" role="alert">
                                    Nenhum "Colaborador" disponível neste momento... comece a cadastrar agora mesmo clicando no botão (+)
                                </div>
                            ) : (
                                <div className="box-expolorar-empresas">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Foto</th>
                                                <th>Nome</th>
                                                <th>Especialidade</th>
                                                <th>% Comissão</th>
                                                <th>Email</th>
                                                <th>Celular</th>
                                                <th>Dt Cadastro</th>
                                                <th className="text-right">Ações</th>
                                            </tr>
                                        </thead>  
                                        <tbody>
                                            {/* {console.log(colaboradores)} */}
                                            {colaboradores.map((colaborador, index) => (
                                                <tr key={colaborador.COL_ID}>
                                                    <td data-label="Id:">{colaborador.COL_ID}</td>
                                                    <td data-label="Foto:">
                                                        {colaborador.COL_FOTOMINI ? (
                                                            <img src={colaborador.COL_FOTOMINI} alt={colaborador.COL_FOTOMINI} height="84" width="56" className="perfil-foto"/>
                                                        ) : (
                                                            'Sem Foto'
                                                        )}
                                                    </td>

                                                    <td data-label="Nome:">{colaborador.COL_NOME}</td>
                                                    <td data-label="Função:">{colaborador.COL_ESPECIALIDADE}</td>
                                                    <td data-label="% Comissão:" className={colaborador.COL_PERCENTUAL_COMISSAO > 0 ? 'text-right highlight-red' : 'text-right'}>
                                                        {colaborador.COL_PERCENTUAL_COMISSAO === 0 && colaborador.COL_PERCENTUAL_COMISSAO === null ? (
                                                            'N/A'
                                                        ) : (
                                                            `${parseFloat(colaborador.COL_PERCENTUAL_COMISSAO).toFixed(2)} %`
                                                        )}
                                                    </td>

                                                    <td data-label="Email:">{colaborador.COL_EMAIL}</td>
                                                    <td data-label="Celular:">
                                                        {colaborador.COL_FONE ? (
                                                            (colaborador.COL_FONE)
                                                        ) : (
                                                            'N/A'
                                                        )}
                                                    </td>
                                                    <td data-label="Dt.Cad:">
                                                        {colaborador.COL_DATACADASTRO ? (
                                                            (colaborador.COL_DATACADASTRO)
                                                        ) : (
                                                            'N/A'
                                                        )}
                                                    </td>

                                                    <td className="text-right" data-label="">
                                                        <button className="btn btn-success m-2" onClick={() => handleAlterar(colaborador)}>
                                                            <Icon path={mdiAccountEdit} size={1} className="me-2"/>Alterar
                                                        </button>
                                                        <button className="btn btn-dark m-2" onClick={() => handleDesativar(colaborador.COL_ID)}>
                                                            <i className="fa fa-recycle me-2" aria-hidden="true"></i>Desativar
                                                        </button>
                                                        <button className="btn btn-danger m-2" onClick={() => handleExcluir(colaborador.COL_ID)}>
                                                            <i className="bi bi-trash-fill me-2"></i>Excluir
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>    
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </>
};

export default Colaboradores;